import { IServiceInstance } from '@module/license/models';
import { SITE_API_URI } from '@service/constants';
import SiteApiClient from '@service/siteApiClient';

const client = new SiteApiClient(SITE_API_URI);

export function requestServicePost(serviceInstance: IServiceInstance, accessToken: string) {
    serviceInstance.id = 0;
    return new Promise(
        (resolve, reject) => {
            client.addService(serviceInstance, accessToken).then(r => r.json()).then(data => {
                resolve(toServiceInstanceResponse(data));
            }).catch((err: any) => {
                reject(err);
            });
        }
    );
}

export function requestServicePut(serviceInstance: IServiceInstance, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            client.updateService(serviceInstance, accessToken).then((response: any) => {
                if (response.ok) {
                    resolve(serviceInstance);
                } else {
                    reject(new Error(response.statusText));
                }
            }).catch((err: any) => {
                reject(err);
            });
        }
    );
}

export function requestServiceDelete(serviceInstance: IServiceInstance, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            client.deleteService(serviceInstance, accessToken).then(data => {
                resolve(serviceInstance);
            });
        }
    );
}

function toServiceInstanceResponse(data: any) {
    const serviceInstanceResponse: IServiceInstance = {
        id: data.id,
        siteId: data.siteId,
        serverId: data.serverId,
        serviceList: [],
        selectedServiceType: data.selectedService,
        assetType: data.selectedService.assetType.assetTypeName,
        allocatedAssets: { value: data.allocatedAssets, valid: true },
        isBeingEdited: false,
        discriminator: ''
    };
    return serviceInstanceResponse;
}
